import React from "react";
import { Table } from "react-bootstrap";
import Loading from "../../../components/loading";
import NoData from "../../components/noData";
import { Pagination } from "antd";

const TicketDetails = ({
  isLoading,
  jobData,
  setTicketModal,
  setTicketNumber,
  page,
  take,
  setPage,
  setTake,
  getDetails
}: any) => {
  return (
    <div>
      {isLoading ? (
        <Loading />
      ) : jobData?.tickets?.data?.length ? (
        <>
          <Table bordered hover>
            <thead>
              <tr style={{ backgroundColor: "#08493e", color: "#fff" }}>
                <th className="table-th">ID</th>
                <th className="table-th">Card No</th>
                <th className="table-th">Ticket No.</th>
                <th className="table-th">Qr Code</th>
                <th className="table-th">Payment Method</th>
                <th className="table-th">Grand Total</th>
                <th className="table-th"></th>
              </tr>
            </thead>
            <tbody>
              {jobData?.tickets?.data?.map((activity: any, index: number) => (
                <tr key={index}>
                  <td>{activity?.id}</td>
                  <td>{activity?.cardNo}</td>
                  <td>{activity?.ticketNumber}</td>
                  <td>{activity?.qrCode}</td>
                  <td>{activity?.paymentMethod}</td>
                  <td>{activity?.grandTotal}</td>
                  <td>
                    <div
                      className="ViewBtn"
                      onClick={() => {
                        setTicketModal(true);
                        setTicketNumber(activity?.ticketNumber);
                      }}
                    >
                      View
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          <div style={{ textAlign: "right", marginTop: 16 }}>
            <Pagination
              current={page || 1}
              pageSize={take || 10}
              total={jobData?.tickets?.meta?.totalItems}
              showSizeChanger
              showTotal={(tot: any) => `Total ${tot} Tickets `}
              onChange={(page: number, pageSize: number) => {
                setPage(page);
                setTake(pageSize);
                getDetails(page, pageSize);
              }}
            />
          </div>
        </>
      ) : (
        <NoData />
      )}
    </div>
  );
};

export default TicketDetails;
